import * as React from "react";
import { Pressable, StyleSheet } from "react-native";
import { get } from "lodash";

import { Video } from "../../types";
import { SPACING } from "../../styles/common";
import { Space } from "../../styled-component";

import Layout from "../common/Layout";
import Text from "../common/Text";

import VideoPreview from "./VideoPreview";
import { Theme } from "../../styles";

export interface VideoCarouselProps {
  videos?: Video[];
}

function VideoCarousel({ videos }: VideoCarouselProps) {
  const [selectedVideoId, setSelectedVideoId] = React.useState(
    get(videos, [0, "id"])
  );

  React.useEffect(() => {
    setSelectedVideoId(get(videos, [0, "id"]));
  }, [videos]);

  return (
    <Layout.Box>
      {videos?.map((video) => (
        <React.Fragment key={video.id}>
          {selectedVideoId === video.id && <VideoPreview url={video.url} />}
        </React.Fragment>
      ))}

      <Layout.Box style={styles.indicators}>
        {videos?.map((video) => (
          <Pressable
            key={video.id}
            style={styles.indicatorContainer}
            onPress={() => setSelectedVideoId(video.id)}
          >
            <Layout.Box
              key={video.id}
              style={[
                styles.indicator,
                selectedVideoId === video.id ? styles.selected : undefined,
              ]}
            />
          </Pressable>
        ))}
      </Layout.Box>
    </Layout.Box>
  );
}

const styles = StyleSheet.create({
  indicators: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  indicator: {
    width: SPACING,
    height: SPACING,
    backgroundColor: Theme.colors.backgroundInfo,
    borderRadius: SPACING,
  },
  selected: {
    backgroundColor: Theme.colors.accent,
  },
  indicatorContainer: {
    padding: SPACING,
  },
});

export default VideoCarousel;
